'use client';
import useFundDetailsForHome from '@/src/hooks/useFundDetailsForHome';
import useFundListForHome from '@/src/hooks/useFundListForHome';
import { ActionType, ModeType, useAppStore, useHomeStore } from '@/src/store';
import { isNullOrBlank } from '@/src/lib/MayzSmartDB';
import { useRouter } from '@/src/store/router/RouterProvider';
import { useEffect, useState } from 'react';
import Deposit from '../Actions/Deposit/Deposit';
import FundDetails from '../Funds/FundDetails/FundDetails/FundDetails';
import FundList from '../Funds/FundList/FundList';
import Swap from '../Actions/Swap/Swap';
import styles from './Home.module.scss';
import Delegate from '../Actions/Delegate/Delegate';
import { isWebsiteDApp } from '@/src/utils/constants';

type PropsTopFunds = {};

export default function Home(props: PropsTopFunds) {
    //--------------------------------------
    const router = useRouter();
    //--------------------------------------
    const { id, action, mode } = router.query;
    //--------------------------------------
    // Fetch data from hooks
    const fundListData = useFundListForHome();
    const fundDetailsData = useFundDetailsForHome({ id: id as string });
    //--------------------------------------
    // Get store setters
    const { currentId, setCurrentId, currentAction, setCurrentAction, currentMode, setCurrentMode } = useHomeStore();
    const appStore = useAppStore();
    //--------------------------------------
    const [isRefreshing, setIsRefreshing] = useState(true);
    //--------------------------------------
    const allowedActions: ActionType[] = isWebsiteDApp ? ['Swap', 'Deposit', 'Delegate'] : ['Swap', 'Deposit'];
    const allowedModes: ModeType[] =
        fundListData.totalItems !== undefined ? (fundListData.totalItems > 1 ? ['List', 'Details'] : fundListData.totalItems === 1 ? ['Details'] : ['List']) : ['List'];
    //--------------------------------------
    // 1. Sync Zustand with URL only if different (URL → Zustand)
    useEffect(() => {
        if (!router.isReady) return;
        // Determine values from URL or default them
        const selectedId = !isNullOrBlank(id as string) ? (id as string) : fundListData.list?.[0]?._DB_id;
        const selectedAction: ActionType = action && allowedActions.includes(action as ActionType) ? (action as ActionType) : allowedActions[0];
        const selectedMode: ModeType = mode && allowedModes.includes(mode as ModeType) ? (mode as ModeType) : allowedModes[0];
        console.log(`[Navigation] URL QUERY Params: id=${selectedId}, action=${selectedAction}, mode=${selectedMode}`);
        // Update Zustand store only if necessary
        if (selectedId !== undefined && selectedId !== currentId) {
            console.log(`[Navigation] Updating currentId from ${currentId} to ${selectedId}`);
            setCurrentId(selectedId);
        }
        if (selectedAction !== currentAction) {
            console.log(`[Navigation] Updating currentAction from ${currentAction} to ${selectedAction}`);
            setCurrentAction(selectedAction);
        }
        if (selectedMode !== currentMode) {
            console.log(`[Navigation] Updating currentMode from ${currentMode} to ${selectedMode}`);
            setCurrentMode(selectedMode);
        }
        const currentQuery = router.query;
        const needsUpdate = currentQuery.action !== selectedAction || currentQuery.mode !== selectedMode ||  currentQuery.id !== selectedId;
        if (needsUpdate) {
            console.log(`[Navigation] Triggering router.replace({ action: ${selectedAction}, mode: ${selectedMode}, id: ${selectedId}}) because query params are different.`);
            router.replace({ pathname: router.pathname, query: { action: selectedAction, mode: selectedMode, id: selectedId } }, undefined, { shallow: true });
        } else {
            // console.log(`[Navigation] Zustand → UR Skipping router, query params are already correct.`);
        }
        setIsRefreshing(false);
    }, [router.isReady, id, action, mode, fundDetailsData.fund, fundListData.list]);
    //--------------------------------------
    // // 2. Sync URL with Zustand only if different (Zustand → URL)
    // useEffect(() => {
    //     if (!router.isReady) return;
    //     if (isRefreshing === true) return;
    //     console.log(`[Navigation] Zustand → UR Selected Params: id=${currentId}, action=${currentAction}, mode=${currentMode}`);
    //     const currentQuery = router.query;
    //     const needsUpdate = currentQuery.action !== currentAction || currentQuery.mode !== currentMode;
    //     if (needsUpdate) {
    //         console.log(`[Navigation] Zustand → UR Triggering router.replace({ id: ${currentId}, action: ${currentAction}, mode: ${currentMode}}) because query params are different.`);
    //         router.replace({ pathname: router.pathname, query: { id: currentId, action: currentAction, mode: currentMode } }, undefined, { shallow: true });
    //     } else {
    //         console.log(`[Navigation] Zustand → UR Skipping router, query params are already correct.`);
    //     }
    // }, [currentAction, currentMode]);
    // //--------------------------------------
    // // 3. ync URL with Zustand only if different (Zustand → URL)
    // useEffect(() => {
    //     if (!router.isReady) return;
    //     if (currentId === undefined) return;
    //     console.log(`[Navigation] Zustand → UR Selected Params: id=${currentId}, action=${currentAction}, mode=${currentMode}`);
    //     fundDetailsData.refreshDetails(currentId);
    //     const currentQuery = router.query;
    //     const needsUpdate = currentQuery.id !== currentId;
    //     if (needsUpdate) {
    //         console.log(`[Navigation] Zustand → UR Triggering router.replace({ id: ${currentId}, action: ${currentAction}, mode: ${currentMode}}) because query params are different.`);
    //         router.replace({ pathname: router.pathname, query: { id: currentId, action: currentAction, mode: currentMode } }, undefined, { shallow: true });
    //     } else {
    //         console.log(`[Navigation] Zustand → UR Skipping router, query params are already correct.`);
    //     }
    // }, [currentId]);
    //--------------------------------------
    return (
        <main className={styles.HomeFundsSection}>
            {/* {`protocol: ${appStore.protocol} `}
            {`protocol: ${fundDetailsData.protocol} `} */}
            {currentAction === 'Swap' ? (
                <Swap {...fundListData} {...fundDetailsData} />
            ) : currentAction === 'Deposit' ? (
                <Deposit {...fundListData} {...fundDetailsData} />
            ) : currentAction === 'Delegate' ? (
                <Delegate {...fundListData} {...fundDetailsData} />
            ) : null}
            {currentMode === 'Details' ? <FundDetails {...fundListData} {...fundDetailsData} /> : <FundList {...fundListData} {...fundDetailsData} />}
        </main>
    );
}
